import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var AlignObjectsCenterIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M12 18.911a1 1 0 01.993.884l.007.116v1.048a1 1 0 01-1.993.117L11 20.959v-1.048a1 1 0 011-1zM15.5 14a1 1 0 011 1v2a1 1 0 01-1 1h-7a1 1 0 01-1-1v-2a1 1 0 011-1h7zm2-8a2 2 0 012 2v3a2 2 0 01-2 2h-11a2 2 0 01-2-2V8a2 2 0 012-2zm0 2h-11v3h11V8zM12 1.911a1 1 0 01.993.884L13 2.91V3.96a1 1 0 01-1.993.117L11 3.959V2.911a1 1 0 011-1z",
                        fillRule: "evenodd"
                    })
                })
            })
        ]
    });
};
AlignObjectsCenterIcon.isCarinaIcon = true;
export default AlignObjectsCenterIcon;
